import { GetterTree } from 'vuex'
import { RootState } from '@/app/common/types/root-state.type'
import { SiteNotificationState } from '@/app/notifications/store/state'

export const getters: GetterTree<SiteNotificationState, RootState> = {}
